import { connect } from 'react-redux';
import PortalEmailConfirmation from './index';
import { resendConfirmationEmail } from './actions';
import { getComponentState } from './reducer';

export default connect(
  state => ({
    isResendingConfirmationEmail: getComponentState(state).ui.isResendingConfirmationEmail,
  }),
  (dispatch, ownProps) => ({
    resendConfirmationEmail: () => dispatch(resendConfirmationEmail(ownProps.identity)),
  })
)(PortalEmailConfirmation);
